const interventionDownloadOptionActions = {
  PROOF: 'HAS_PROOF',
  IC: 'HAS_INFORMED_CONSENT'
};

const interventionDownloadOptionPermission = {
  PROOF: 'intervention:download_proof',
  IC: 'intervention:download_ic'
};

const interventionProofDeliveryMethod = {
  WEB: 'WEB',
  EMAIL: 'EMAIL'
};

const interventionStates = {
  COMPLETED: 3,
  CONFIRMED: 17,
  IN_PROGRESS: 23,
  IN_PREPARATION: 28,
  IN_RECOVERY: 29,
  COMPLETED_BRACELET_REMOVAL: 30,
  CLOSED: 31,
  ADMISSION_HANDLED: 32,
  PATIENT_CALLED: 33
};

const interventionIncludedStates = [
  interventionStates.COMPLETED,
  interventionStates.CONFIRMED,
  interventionStates.IN_PROGRESS,
  interventionStates.IN_PREPARATION,
  interventionStates.IN_RECOVERY,
  interventionStates.COMPLETED_BRACELET_REMOVAL,
  interventionStates.CLOSED,
  interventionStates.ADMISSION_HANDLED,
  interventionStates.PATIENT_CALLED
];

export {
  interventionDownloadOptionActions,
  interventionDownloadOptionPermission,
  interventionProofDeliveryMethod,
  interventionIncludedStates
};
